var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"inner-wrap"},[_c('CVFiles',{attrs:{"id":"cv-inner","allow-editing":true,"display-all":true,"footer-text":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }